<template>
  <validation-provider
    v-slot="{ errors }"
    mode="eager"
    :name="tag.description"
    :rules="tag.custom_settings.validation || ''"
  >
    <div
      v-if="tag.realm_dic_id && tag.custom_settings.allow_dic_add"
      :id="`form-string-autocomplete-${tag.name}-${uniqid}`"
      class="select-container"
    >
      <v-autocomplete
        v-model="formData"
        :label="tag.description"
        outlined
        dense
        :error-messages="errors"
        :readonly="readonly"
        :items="dic"
        item-text="value"
        item-value="term"
        :attach="`#form-string-autocomplete-${tag.name}-${uniqid}`"
        @change="testAndEmitTitleChange"
      />
    </div>
    <div
      v-else-if="tag.realm_dic_id"
      :id="`form-string-select-${tag.name}-${uniqid}`"
      class="select-container"
    >
      <v-select
        v-model="formData"
        :label="tag.description"
        outlined
        dense
        :error-messages="errors"
        :readonly="readonly"
        :items="dic"
        item-text="value"
        item-value="term"
        :attach="`#form-string-select-${tag.name}-${uniqid}`"
        :menu-props="{
          nudgeBottom: 40
        }"
        @change="testAndEmitTitleChange"
      />
    </div>
    <v-text-field
      v-else
      :id="`form-text-field-${tag.name}-${uniqid}`"
      v-model="formData"
      :label="tag.description"
      outlined
      dense
      :error-messages="errors"
      :readonly="readonly"
      @input="testAndEmitTitleChange"
    />
  </validation-provider>
</template>

<script>
import { computed } from "vue";
import uniqueId from "lodash/uniqueId";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    dic: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    items() {
      const lang = this.$store.getters.getLang;
      return this.$store.getters.getDic(this.tag.realm_dic_id, lang);
    },
    uniqid() {
      return uniqueId();
    }
  },

  methods: {
    testAndEmitTitleChange(val) {
      if (this.tag.name == "title") {
        this.$emit("title-change", val);
      }
    }
  },

  setup(props, { emit }) {
    const formData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    return {
      formData
    };
  }
};
</script>
<style scoped>
.select-container {
  position: relative;
}
</style>
